import React from "react";
import { Download } from "lucide-react";
import { useInstall } from "@/contexts/InstallContext";

/**
 * Renders nothing once the app is installed or the browser gives us no way
 * to install it (canInstall covers both the native-prompt and iOS cases).
 */
export default function InstallAppButton({ className = "", variant = "dark", iconOnly = false, children, ...rest }) {
  const { canInstall, promptInstall } = useInstall();
  if (!canInstall) return null;

  const base = variant === "light"
    ? "bg-white text-black hover:bg-slate-100 border border-slate-200"
    : "bg-black text-white hover:bg-slate-800";

  if (iconOnly) {
    return (
      <button
        type="button"
        onClick={promptInstall}
        data-testid="install-app-btn"
        aria-label="Install App"
        className={`flex items-center justify-center rounded-full w-8 h-8 shrink-0 ${base} ${className}`}
        {...rest}
      >
        <Download className="w-4 h-4" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={promptInstall}
      data-testid="install-app-btn"
      className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold transition ${base} ${className}`}
      {...rest}
    >
      <Download className="w-4 h-4" />
      {children || "Install App"}
    </button>
  );
}
